import { t } from "ttag";

import { Box, Card, Stack, Text, Title } from "metabase/ui";
import type { EmbeddingHomepageDismissReason } from "metabase-types/api";

import { HeaderWithDismiss } from "./HeaderWithDismiss";
import { InteractiveContent } from "./InteractiveContent";
import { NeedMoreInfoCard } from "./NeedMoreInfoCard";
import { SDKContent } from "./SDKContent";
import { StaticEmbedContent } from "./StaticEmbedContent";

export type EmbedHomepageViewProps = {
  exampleDashboardId: number | null;
  licenseActiveAtSetup: boolean;
  onDismiss: (reason: EmbeddingHomepageDismissReason) => void;
  // links
  interactiveEmbeddingQuickstartUrl: string;
  learnMoreInteractiveEmbedUrl: string;
  learnMoreStaticEmbedUrl: string;
  sdkQuickstartUrl: string;
  sdkDocsUrl: string;
  embeddingDocsUrl: string;
  analyticsDocsUrl: string;
};

export const EmbedHomepageView = (props: EmbedHomepageViewProps) => {
  const {
    interactiveEmbeddingQuickstartUrl,
    exampleDashboardId,
    learnMoreStaticEmbedUrl,
    learnMoreInteractiveEmbedUrl,
    sdkQuickstartUrl,
    sdkDocsUrl,
    onDismiss,
    embeddingDocsUrl,
    analyticsDocsUrl,
  } = props;

  const exampleDashboardLink = exampleDashboardId
    ? `/dashboard/${exampleDashboardId}`
    : undefined;

  return (
    <Stack maw={550}>
      <HeaderWithDismiss onDismiss={onDismiss} />

      <Card px="xl" py="lg">
        <Stack gap="xl">
          <Box>
            {/* eslint-disable-next-line no-literarel-metabase-strings -- only visible to admins */}
            <Title order={2} mb="md">{t`Dashpoint Report Designer`}</Title>
            <Text>
              {/* eslint-disable-next-line no-literal-metabase-strings -- only visible to admins */}
              {t`Dashpoint нь бизнесүүдэд өгөгдлөө үр ашигтай удирдаж, өөрсдийн шаардлагад нийцсэн тайлан, хяналтын самбар гаргахад зориулагдсан ухаалаг шийдэл юм. Бид хэрэглэгчиддээ техникийн гүнзгий мэдлэггүйгээр ч хүссэн өгөгдлөө сонгож, хүссэн тохиргоотойгоороо тайлан, хяналтын самбараа хийж, тэдгээрийгээ хуваалцах, үр дүнтэй өгөгдөл дээр суурилсан шийдвэр гаргах боломжийг олгодог. Dashpoint нь өгөгдлөө үр дүнтэй ашиглах таны анхны алхам юм.`}
            </Text>
          </Box>
        </Stack>
      </Card>
    </Stack>
  );
};
